import api from '@/utils/api';
import {Commit} from "vuex";

const state = {};
const mutations = {};

const getters = {};
const actions = {

  // 用户数据迁移申请
  async api_cryptbox_device_data_migration_user_list(_commit, params) {
    return api.post('/api/distribute/cryptbox/device_data_migration/user_apply_list', params);
  },
  async api_cryptbox_device_data_migration_save(_commit, params) {
    return api.post('/api/distribute/cryptbox/device_data_migration/save_apply', params);
  },
  async api_list_cryptbox_user_device (_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/cryptbox/list_user_device', params)
  },
  async api_cryptbox_device_query_mis_id(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/cryptbox/device_data_migration/query_mis_id', params)
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};
